/* eslint-disable */
const hash = {
  "en-US": "c1404e4e",
  "de-DE": "0e8d2319",
  "es-ES": "8625796b",
  "fr-FR": "73948f5e",
  "id-ID": "409a5250",
  "it-IT": "f5ad3f4d",
  "jp-JP": "b78dc5aa",
  "ko-KO": "4316367e",
  "nl-NL": "70672bad",
  "pl-PL": "47db2da9",
  "pt-PT": "11b99faf",
  "ru-RU": "9ec1c003",
  "sv-SE": "2205b1b6",
  "tr-TR": "5717a0e7",
  "vi-VN": "7275a3c1",
  "zh-CN": "d6ff605a",
  "zh-TW": "5ae88f6d",
  "avatars": "fb16c7a2",
  "control": "82b2a82c",
  "plan-details": "24f2475e",
  "gov-EN": "cce45666",
  "en-GB": "c4a88fa3"
}
export default hash
